import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "validator" }
const _hoisted_2 = { class: "validator-bar" }
const _hoisted_3 = { class: "validator-bar-text" }
const _hoisted_4 = { class: "validator-rules" }

import { computed, watchEffect } from 'vue';

interface Props {
  passwordInput: string;
}

interface PasswordStrength {
  title: string;
  className: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaPasswordValidator',
  props: {
    passwordInput: {}
  },
  emits: ['passwordValidity'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const password = computed(() => props.passwordInput);

// Правила для проверки пароля
const rules = computed(() => ({
  isAtLeast8: password.value.length >= 8,
  isAtLeast10: password.value.length >= 10,
  isAtLeast12: password.value.length >= 12,
  hasDigit: /\d/.test(password.value),
  hasLowercase: /[a-z]/.test(password.value),
  isOnlyLatinLetters: /^(?!.*[А-Яа-яЁё]).*[A-Za-z]/.test(password.value),
  isSpecial: /[!&^%#$@()/=\\.,|<>+\-{}]/.test(password.value),
  isCapital: /[A-Z]/.test(password.value),
  isNoSpaceKey: !/\s/.test(password.value)
}));

// Проверяем соответствие основным требованиям
const isPassConditions = computed(() => {
  const { hasDigit, hasLowercase, isOnlyLatinLetters, isSpecial, isCapital, isNoSpaceKey } = rules.value;
  return hasDigit && hasLowercase && isOnlyLatinLetters && isSpecial && isCapital && isNoSpaceKey;
});

// Определяем сложность пароля
const passwordStrength = computed<PasswordStrength>(() => {
  const { isAtLeast8, isAtLeast10, isAtLeast12 } = rules.value;

  if (!isAtLeast8 || !isPassConditions.value) return { title: 'Недопустимый пароль', className: 'isShort' };
  if (isAtLeast8 && !isAtLeast10) return { title: 'Слабый пароль', className: 'isWeak' };
  if (isAtLeast10 && !isAtLeast12) return { title: 'Хороший пароль', className: 'isFair' };
  if (isAtLeast12) return { title: 'Надежный пароль', className: 'isExcellent' };

  return { title: '', className: '' };
});

const isValid = computed(() => passwordStrength.value.className !== 'isShort');

watchEffect(() => {
  emit('passwordValidity', isValid.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["validator-bar-color", passwordStrength.value.className])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(passwordStrength.value.title), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.isAtLeast8 })
      }, "Минимум 8 символов", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.isOnlyLatinLetters })
      }, "Только латинские буквы", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.hasLowercase })
      }, "Минимум 1 строчная буква", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.isCapital })
      }, "Не менее 1 заглавной буквы", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.hasDigit })
      }, "Не менее 1 цифры", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.isSpecial })
      }, "Не менее 1 спецсимвола", 2),
      _createElementVNode("li", {
        class: _normalizeClass({ checked: rules.value.isNoSpaceKey })
      }, "Отсутствие пробелов", 2)
    ])
  ]))
}
}

})